import { SET_PAYMENT_METHODS } from '../actionTypes'

const defaultState = {
  methods: []
}

export default (state = defaultState, action: {type: string, payload: any}) => {
  switch (action.type) {
    case SET_PAYMENT_METHODS: return {...state, methods: action.payload}
    default: return state
  }
}
